import React from "react";
import { Box, Button, Container, Heading, Text, Flex } from "@chakra-ui/react";
import { FaWhatsapp } from "react-icons/fa";

const Hero: React.FC = () => {
  return (
    <Box
      bg="brand.lightGray.100"
      bgImage={{
        base: "url('/images/Home/banner.jpg')",
        lg: "url('/images/Home/home.jpg')",
      }}
      backgroundPosition={{ base: "bottom", lg: "center" }}
      bgRepeat="no-repeat"
      bgSize="cover"
      py={20}
      // px={8}
      position="relative"
      width="100%"
      height={{ base: "110vh", lg: "100%" }}
    >
      <Container
        my={{ base: "auto", md: "auto", lg: "96px" }}
        mx={{ base: "auto", md: "auto", lg: "128px" }}
      >
        <Flex>
          <Box maxW="600px">
            <Heading
              as="h1"
              fontSize={{ base: "32px", md: "48px", lg: "50px" }}
              color="brand.blue.100"
              fontWeight="bold"
              fontFamily="cofo-kabeltouw-solid-0, sans-serif"
              lineHeight="1.2"
              mb={{ base: "20px", md: "20px", lg: "24px" }}
              fontStyle="uppercase"
            >
              Aluguel de equipamentos em Joinville e Araquari para sua obra
            </Heading>

            <Box maxW={"550px"}>
              <Text
                fontWeight="light"
                fontSize={{ base: "20px", md: "22px", lg: "24px" }}
                mb={{ base: "20px", md: "20px", lg: "48px" }}
              >
                A ServiMaq é referência em aluguel de equipamentos para{" "}
                <Text as="span" fontWeight="bold">
                  construção civil em Joinville e Araquari,
                </Text>{" "}
                com mais de
                <Text as="span" color="brand.blue.100" fontWeight="bold">
                  {" "}
                  10 anos de experiência
                </Text>
              </Text>
            </Box>

            <Button
              as="a"
              href={`https://wa.me/5547984572151?text=${encodeURIComponent("Olá! Vim pelo site e gostaria de saber mais informações sobre os equipamentos disponíveis.")}`}
              bg="brand.yellow.100"
              color="brand.blue.100"
              size="lg"
              borderRadius="md"
              _hover={{ bg: "#FFD54F" }}
              px={6}
            >
              <FaWhatsapp />
              SOLICITAR ORÇAMENTO
            </Button>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

export default Hero;
